
export class WorkOrderAbridged {
  id: number;
  description: string;

  public deserialize(input: any): this {
    this.id = input.id;
    this.description = input.description;

    return this;
  }
};
